"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoggedInState = void 0;
var LoggedInState;
(function (LoggedInState) {
    LoggedInState["YES"] = "yes";
    LoggedInState["NO"] = "no";
})(LoggedInState || (exports.LoggedInState = LoggedInState = {}));
//# sourceMappingURL=LoggedInState.js.map